import type { FaireProductEntity } from "../../entity_types/product";

export const p_auemmthr6z: FaireProductEntity = {
  token: "p_auemmthr6z",
  type: "product",
  name: "Hummingbird Hand-Painted Porcelain Dinner Plate – 8 in. Round",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/087c62adc87e8d8c295ddd007d55c55ba5817fa0bd7fed718c912d6d02b7cece.png",
  galleryImageUrls: [],
  priceDollars: 5.5,
  description: "Bring a refined, restaurant-ready look to the table with this 8\" hand-painted dinner plate. A versatile plate for entrées, rice dishes, salads and shared plates. A hand-painted hummingbird design decorates the plate. Made from restaurant-grade porcelain, it is built for busy restaurants, sushi bars, ramen shops, cafés and catering, while looking just as good on the family dinner table. A thoughtful gift for home cooks, it brings the look of Japanese ceramic pottery to any kitchen.\n\nFeatures\n\n * Restaurant-grade porcelain: made for the demands of daily commercial service \n * Easy care: microwave and dishwasher safe \n * Coordinated collection: mix with the other 8 in. designs: Spring Bee, Koi Fish, Maple Leaf, Cherry Blossoms and Panda Plum Blossoms \nSpecifications\n\n * Size: 8\" Dia x 1\" H \n * Material: Porcelain (restaurant grade) \n * Design: Hummingbird \n * Inner pack: 4 \n * Case pack: 32 \n * Origin: China \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:37.315Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
